export enum Controls {
  fullControlBar,
  partialControlBar,
  nonInteractiveSeekBar,
  native,
  none,
}
